<template>
  <BModal id="modal-download-komchat" ref="modal-download-komchat" hide-footer hide-header centered size="lg"
    dialog-class="modal-wider">
    <div class="p-1">
      <div class="text-xl font-semibold text-center">
        Download Data Partner
      </div>
      <div class="text-sm text-gray-500 text-center mb-3">
        Filter data yang ingin kamu download
      </div>
      <div class="max-sm:!hidden flex gap-2">
        <div class="w-[280px]">By Date</div>
        <div class="flex-1 grid grid-cols-3 gap-2">
          <div>By Status</div>
          <div>By Product</div>
          <div>By Services</div>
        </div>
      </div>
      <hr class="max-sm:hidden my-1 border-gray-200 border-2">
      <div class="flex flex-col gap-2">
        <div class="flex max-sm:flex-col gap-2">
          <div class="w-[280px] max-sm:mb-6">
            <DateRangePicker v-model="dateRange" :locale-data="locale" :ranges="rangesDate" :opens="pickerOpens" class="w-[200px]"> <template
                v-slot:input="picker">
                <div class="flex justify-between gap-2 w-full">
                  <span class="truncate ... leading-[1.9]"
                    :class="dateRange.startDate ? 'text-black' : 'text-gray-400'">
                    {{ dateRange.startDate && dateRange.endDate ? picker.rangeText : 'Pilih tanggal' }}
                  </span>

                  <span class="k-calendar pl-[7px]  text-[21px]" />
                </div>
              </template>
            </DateRangePicker>
          </div>
          <div class="flex-1 grid grid-cols-3 gap-2">
            <div>
              <div v-for="(option, index) in status" :key="index" class="mb-1">
                <b-form-checkbox v-model="filter.status" :name="`checkbox-${index}`" class="text-6 "
                  :value="option.value">
                  {{ option.label }}
                </b-form-checkbox>
              </div>
            </div>
            <div>
              <div v-for="(option, index) in typeProduct" :key="index" class="mb-1">
                <b-form-checkbox v-model="filter.typeProduct" :name="`checkbox-${index}`" :value="option.value"
                  class="text-6">
                  {{ option.label }}
                </b-form-checkbox>
              </div>
            </div>
            <div>
              <div v-for="(option, index) in typeServices" :key="index" class="mb-1">
                <b-form-checkbox v-model="filter.typeServices" :name="`checkbox-${index}`" :value="option.value"
                  class="text-6">
                  {{ option.label }}
                </b-form-checkbox>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="w-full gap-[8px] mt-3 flex justify-end">
        <b-button variant="outline-primary" @click="$bvModal.hide('modal-download-komchat')">
          Batal
        </b-button>
        <b-button variant="primary"
          :disabled="isLoading || (dateRange.startDate === '' || dateRange.endDate === '' || (filter.status.length === 0 && filter.typeProduct.length === 0 && filter.typeServices.length === 0))"
          @click="getDownloadPartner()">
          <BSpinner v-if="isLoading" small />
          Download Excel
        </b-button>
      </div>
    </div>
  </BModal>
</template>
<script>
import DateRangePicker from 'vue2-daterange-picker'
import { LABELDAY, LABELMONTH, YEAR_MONTH_DAY } from '@/libs/filterDate'
import {
  status,
  typeProduct,
  typeServices,
  rangesDate,
} from '../config'
import { apiDownloadPartnerKomchat } from '../services/api.komchat.service'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'

export default {
  name: 'ModalDownload',
  components: {
    DateRangePicker,
  },
  data() {
    return {
      windowWidth: window.innerWidth,
      dateRange: {
        startDate: '',
        endDate: '',
      },
      filter: {
        status: [],
        typeProduct: [],
        typeServices: [],
      },
      status,
      typeProduct,
      typeServices,
      rangesDate,
      isLoading: false,
      locale: {
        format: 'yyyy-mm-dd',
        daysOfWeek: LABELDAY,
        monthNames: LABELMONTH,
      },
    }
  },
  computed: {
    pickerOpens() {
      return this.windowWidth < 768 ? 'right' : 'center'
    },
  },
  mounted() {
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    handleResize() {
      this.windowWidth = window.innerWidth
    },
    async getDownloadPartner() {
      try {
        this.isLoading = true

        const baseParams = {
          start_date: YEAR_MONTH_DAY(this.dateRange.startDate),
          end_date: YEAR_MONTH_DAY(this.dateRange.endDate),
          status: this.filter.status.join(','),
        }

        const requests = []

        if (this.filter.status.length > 0 || this.filter.typeProduct.length > 0) {
          const combinedParams = { ...baseParams }
          if (this.filter.typeProduct.length > 0) {
            combinedParams.product_type = this.filter.typeProduct.join(',')
          }
          requests.push({ params: combinedParams, suffix: '' })
        }

        this.filter.typeServices.forEach(service => {
          requests.push({
            params: { ...baseParams, service },
            suffix: service,
          })
        })

        // eslint-disable-next-line no-restricted-syntax
        for (const { params, suffix } of requests) {
          // eslint-disable-next-line no-await-in-loop
          const { data } = await apiDownloadPartnerKomchat(params)
          const url = window.URL.createObjectURL(new Blob([data]))
          const link = document.createElement('a')
          link.href = url
          if (!suffix) {
            link.setAttribute('download', `data-partner-komchat-${new Date().toISOString().slice(0, 10)}.xlsx`)
          } else {
            link.setAttribute('download', `data-partner-komchat-${suffix}-${new Date().toISOString().slice(0, 10)}.xlsx`)
          }
          document.body.appendChild(link)
          link.click()
          link.remove()
          window.URL.revokeObjectURL(url)
        }

        this.isLoading = false
        this.$bvModal.hide('modal-download-komchat')
      } catch (err) {
        this.$toast_error({ message: 'Gagal unduh data partner', err })
        this.isLoading = false
      }
    },
  },
}

</script>

<style>
.modal-wider {
  max-width: 900px !important;
  width: 900px !important;
}

@media (max-width: 960px) {
  .modal-wider {
    max-width: 95vw !important;
    width: 95vw !important;
  }
}
</style>
